import React from "react"
import ManualCadastroPage from "./cadastro-manual"

const MotorCadastroOcrPage = () => <ManualCadastroPage variant="ocr" />

export default MotorCadastroOcrPage
